import classNames from 'classnames';
import defaultCss from './SingleMenuItemSub.module.scss';
import { A } from '../../../../../../hybrid/wrappers';

const SingleMenuItemSub = ({ componentCss, showSubMenu, idx, showSubMenuIdx, menuItem, active, isActive, isMobile }) => {
    return (
        <div
            className={classNames(componentCss?.subMenuWrapper)}
            style={{
                ...(showSubMenu && idx === showSubMenuIdx ? { paddingBottom: '8px' } : { display: 'none' })
            }}
        >
            {menuItem?.submenu.map((item, idx) => {
                const href =
                    item.type === 'outLink'
                        ? `https://${item.asLink}`
                        : item.type === 'link' || item.type === 'page'
                        ? `${item.type === 'page' ? '/page' : ''}${item.asLink}`
                        : 'javascript:void(0)';

                const isActiveSub = item.asLink === active;
                return (
                    <A
                        href={href}
                        target={item?.target ? '_blank' : '_self'}
                        key={`submenuItem${idx}`}
                        className={classNames(
                            defaultCss.singleSubMenuItem,
                            componentCss?.singleSubMenuItem,
                            isActiveSub ? componentCss?.singleSubMenuItem : null
                        )}
                    >
                        <span className={componentCss?.officeMenuItemText}>
                            {item.type === 'outLink' ? (
                                <span
                                    className={classNames(
                                        defaultCss.officeMenuItemTextP,
                                        componentCss?.officeMenuItemTextP,
                                        isActive && componentCss?.officeMenuItemTextHover
                                    )}
                                >
                                    <div
                                        style={{
                                            color: !isMobile ? 'var(--darkColor)' : 'var(--blueTotalGray)'
                                        }}
                                        className={defaultCss.linkHover}
                                    >
                                        {item.title}
                                    </div>
                                </span>
                            ) : item.type === 'link' || item.type === 'page' ? (
                                <span
                                    style={{
                                        color: !isMobile ? 'var(--darkColor)' : 'var(--blueTotalGray)'
                                    }}
                                    className={defaultCss.linkHover}
                                >
                                    {item.title}
                                </span>
                            ) : (
                                item.title
                            )}
                        </span>
                    </A>
                );
            })}
        </div>
    );
};
export default SingleMenuItemSub;
